import projectionGrid from 'projection-grid';
import { columnChooserPlugin } from '@bingads-webui-campaign/projection-grid-column-chooser';
import { inlineDownloadWithoutFilterstateAndSegmentPlugin } from '@bingads-webui-campaign/projection-grid-inline-download';
import { assistedSelectionPlugin } from '@bingads-webui/projection-grid-assisted-selection';
import { editablePlugin } from '@bingads-webui-campaign/projection-grid-editable';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { dateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { toolbarPlugin } from '@bingads-webui/projection-grid-toolbar';
import { treePlugin } from '@bingads-webui/projection-grid-tree';
import { clientSideSortPlugin } from '@bingads-webui/projection-grid-client-sort';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';
import { inlineErrorPlugin } from '@bingads-webui/projection-grid-inline-error';
import { aggregatedRowsPlugin } from '@bingads-webui/projection-grid-aggregated-rows';
import { performanceLogPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { jsdataRawDataPlugin } from '@bingads-webui-campaign/projection-grid-js-data-raw-data';
import { ProductGroupsGridConfig } from '../common/view/product-groups-grid-config';
import AbstractProductGroupsView from '../common/view/abstract-product-groups-grid';

class TreeProductGroupsView extends AbstractProductGroupsView {
  initialize(options) {
    this.isTreeView = true;
    super.initialize(options);
  }

  getGridConfig() {
    return new ProductGroupsGridConfig({
      deps: this.deps,
      view: this,
      isTreeView: this.isTreeView,
      dataSource: this.gridParameters.dataSource,
      onTogglePillClicked: this.callbacks.onTogglePillClicked,
    });
  }

  initializeGridFactory() {
    return projectionGrid
      .factory({ vnext: true })
      .use(jsdataRawDataPlugin)
      .use(performanceLogPlugin)
      .use(dateFilterPlugin)
      // .use(this.dateFilterRefreshPlugin)
      .use(clientSideSortPlugin)
      .use(toolbarPlugin)
      .use(columnChooserPlugin)
      .use(treePlugin)
      .use(editablePlugin)
      .use(assistedSelectionPlugin)
      .use(inlineErrorPlugin({
        errorIconClasses: ['grid-error', 'spritedimage'],
      }))
      .use(uiBlockerPlugin)
      .use(placeholderPlugin)
      .use(inlineDownloadWithoutFilterstateAndSegmentPlugin)
      .use(aggregatedRowsPlugin({
        bottom: {
          getRows: (items, { view }) => [{
            item: {
              total: this.deps.i18n.getString('ProductGroupsGrid_TotalSummary', { count: view.getItemCount() }),
              isAggregateRow: true,
            },
            classes: `bottom-aggregated-row-${0}`,
          }],
        },
      }));
  }
}

export default TreeProductGroupsView;
